module.exports = __webpack_public_path__ + "img/banner_hero.88980c32.png";